var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5.334 8.332 2 2 3.334-4",
    stroke: "#255201",
    strokeWidth: 1.333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.001 14.665a6.667 6.667 0 1 0 0-13.333 6.667 6.667 0 0 0 0 13.333z",
    stroke: "#255201",
    strokeWidth: 1.333
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSuccess);
export default __webpack_public_path__ + "static/media/check-success.7af025f4cdb132bc5cc719a62ace4b14.svg";
export { ForwardRef as ReactComponent };